import { Injectable } from "@angular/core";
import { RestangularModule, Restangular } from "ngx-restangular";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class ObjectivesService {
  constructor(private restangular: Restangular, private http: HttpClient) {}

  public getObjectives() {
    return this.restangular.one("getObjectives");
  }

  public addObjective() {
    return this.restangular.all("addObjective");
  }

  public deleteObjective(id) {
    return this.restangular.one("deleteObjective/" + id);
  }

  public getObjectiveEdit(id) {
    return this.restangular.one("getObjectiveEdit/" + id);
  }

  public updateObjective(id) {
    return this.restangular.one("updateObjective/" + id);
  }

  public updateObjectiveSettings(id) {
    return this.restangular.one("updateObjectiveSettings/" + id);
  }


  public getObjectiveSettingsByEmp(id) {
    return this.restangular.one("getObjectiveSettingsByEmp/" + id);
  }



  public addGenerate() {
    return this.restangular.all("addGenerate");
  }

  public retrieveGenerate(id) {
    return this.restangular.one("retrieveGenerate/" + id);
  }

  public retrieveObjRatings() {
    return this.restangular.one("retrieveObjRatings");
  }

  public deleteGenerate(id) {
    return this.restangular.one("deleteGenerate/" + id);
  }

  public addMapDesig() {
    return this.restangular.all("addMapDesig");
  }

  public retrieveMapDesig(id) {
    return this.restangular.one("retrieveMapDesig/" + id);
  }

  public getEditMapDesig(id) {
    return this.restangular.one("getEditMapDesig/" + id);
  }

  public updateMapDesig(id) {
    return this.restangular.one("updateMapDesig/" + id);
  }

  public updateMapAssessor(id) {
    return this.restangular.one("updateMapAssessor/" + id);
  }


  public deleteMapDesig(id) {
    return this.restangular.one("deleteMapDesig/" + id);
  }

  public loadElements() {
    return this.restangular.one("loadElements");
  }

  public loadCompElements() {
    return this.restangular.one("loadCompElements");
  }

  public addTemplateData_01() {
    return this.restangular.all("addTemplateData_01");
  }

  public getDynamicRecords() {
    return this.restangular.one("getDynamicRecords");
  }

  public removeItemPP(id) {
    return this.restangular.one("removeItemPP/" + id);
  }

  public removeItemTemp(id) {
    return this.restangular.one("removeItemTemp/" + id);
  }


  
  public showTemplate(id) {
    return this.restangular.one("showTemplate/" + id);
  }


  public getShowTemplateAccess(id) {
    return this.restangular.one("getShowTemplateAccess/" + id);
  }

  public getDynamicRecordsConfirmed() {
    return this.restangular.one("getDynamicRecordsConfirmed");
  }





  // ------------------------ CREATE OBJECTIVE ASSESSMENT ------------------------- //
  public getCreateObjAssess() {
    return this.restangular.one("getCreateObjAssess");
  }

  public createObjAssess() {
    return this.restangular.all("createObjAssess");
  }

  public deleteCreatedObjAsses(id) {
    return this.restangular.one("deleteCreatedObjAsses/" + id);
  }

  public getObjAssess(id) {
    return this.restangular.one("getObjAssess/" + id);
  }

  public updateObjAssess(id) {
    return this.restangular.one("updateObjAssess/" + id);
  }

  public updateRatingRecord(id) {
    return this.restangular.one("updateRatingRecord/" + id);
  }

  

  public getObjDesignations(id) {
    return this.restangular.one("getObjDesignations/" + id);
  }

  public getObjDesignationsName(id) {
    return this.restangular.one("getObjDesignationsName/" + id);
  }


  public deleteCreateNewObj_Desig(id) {
    return this.restangular.one("deleteCreateNewObj_Desig/" + id);
  }

  public addNewObjDesig() {
    return this.restangular.all("addNewObjDesig");
  }

  public getObjEmployees(id) {
    return this.restangular.one("getObjEmployees/" + id);
  }

  public deleteCreateNewObj_Emp(id) {
    return this.restangular.one("deleteCreateNewObj_Emp/" + id);
  }

  public getGenerateTemplate(id) {
    return this.restangular.one("getGenerateTemplate/" + id);
  }

  public getHeaderRatings(id) {
    return this.restangular.one("getHeaderRatings/" + id);
  }

  public templateSaveAsDraft(id) {
    return this.restangular.one("templateSaveAsDraft/" + id);
  }






    // ------------------------ MY OBJECTIVE ASSESSMENT ------------------------- //
    // public getMyObjAssess() {
    //   return this.restangular.one("getMyObjAssess");
    // }

    // public getMyObjAssess(id) {
    //   return this.restangular.one("getMyObjAssess/" + id);
    // }

    public getMyObjAssess() {
      return this.restangular.one("getMyObjAssess");
    }


    public getMyObjAssessTab01() {
      return this.restangular.one("getMyObjAssessTab01");
    }



    // public getAssignObjAssess(id) {
    //   return this.restangular.one("getAssignObjAssess/" + id);
    // }

    public getAssignObjAssess() {
      return this.restangular.one("getAssignObjAssess");
    }



    public getAssignObjAssessTab02() {
      return this.restangular.one("getAssignObjAssessTab02");
    }



    // public getLevelObjAssess(id) {
    //   return this.restangular.one("getLevelObjAssess/" + id);
    // }

    public getLevelObjAssess() {
      return this.restangular.one("getLevelObjAssess");
    }



    public getLevelObjAssessTab03() {
      return this.restangular.one("getLevelObjAssessTab03");
    }




    public templateSendToEmployees() {
      return this.restangular.all("templateSendToEmployees");
    }


    public startMyObjective_1(id) {
      return this.restangular.one("startMyObjective_1/" + id);
    }

    public getMyObjectiveRatings(id) {
      return this.restangular.one("getMyObjectiveRatings/" + id);
    }

    public getMyObjectiveSubmittedRatings(id) {
      return this.restangular.one("getMyObjectiveSubmittedRatings/" + id);
    }





    public getMyObjectiveTemplate(id) {
      return this.restangular.one("getMyObjectiveTemplate/" + id);
    }


    public getMyObjectiveTemplate_02(id) {
      return this.restangular.one("getMyObjectiveTemplate_02/" + id);
    }

    public getMyObjectiveLevelApprovals(id) {
      return this.restangular.one("getMyObjectiveLevelApprovals/" + id);
    }

    public approvedManagerLevel() {
      return this.restangular.one("approvedManagerLevel");
    }




    public updateMyAssesTab_01() {
      return this.restangular.one("updateMyAssesTab_01");
    }

    public updateMyAssesTab_02() {
      return this.restangular.one("updateMyAssesTab_02");
    }

    public updateMyAssesTab_03() {
      return this.restangular.one("updateMyAssesTab_03");
    }



    public completeAssessorOnly() {
      return this.restangular.one("completeAssessorOnly");
    }

    public completeManagerOnly() {
      return this.restangular.one("completeManagerOnly");
    }


    public completeAssessorOnlyRetake() {
      return this.restangular.one("completeAssessorOnlyRetake");
    }







    public checkedMyAssesTab_01() {
      return this.restangular.all("checkedMyAssesTab_01");
    }




    // REFERBACK - SELF //
    public referBackMyAssesTab_01() {
      return this.restangular.all("referBackMyAssesTab_01");
    }

    public referBackMyAssesTab_01_Cmnts() {
      return this.restangular.one("referBackMyAssesTab_01_Cmnts");
    }

    public referBackMyAssesTab_01_Attchmnt() {
      return this.restangular.all("referBackMyAssesTab_01_Attchmnt");
    }


    // REFERBACK - MANAGER //
    public referBackMyAssesTab_02() {
      return this.restangular.all("referBackMyAssesTab_02");
    }

    public referBackMyAssesTab_02_Cmnts() {
      return this.restangular.one("referBackMyAssesTab_02_Cmnts");
    }

    public referBackMyAssesTab_02_Attchmnt() {
      return this.restangular.all("referBackMyAssesTab_02_Attchmnt");
    }







    public checkedMyAssesTab_02() {
      return this.restangular.one("checkedMyAssesTab_02");
    }

    public checkedMyAssesTab_03() {
      return this.restangular.one("checkedMyAssesTab_03");
    }

    public getMyObjectiveMarks(id) {
      return this.restangular.one("getMyObjectiveMarks/" + id);
    }

    public getMyObjectiveMarksOnly(id) {
      return this.restangular.one("getMyObjectiveMarksOnly/" + id);
    }





    public footerSubmitTab_01() {
      return this.restangular.all("footerSubmitTab_01");
    }

    public footerGetTab_01(id) {
      return this.restangular.one("footerGetTab_01/" + id);
    }

    public footerGetTab_02(id) {
      return this.restangular.one("footerGetTab_02/" + id);
    }

    public footerGetTab_03(id) {
      return this.restangular.one("footerGetTab_03/" + id);
    }





    public submitAttachmentTab01() {
      return this.restangular.all("submitAttachmentTab01");
    }

    public getAttachmentTab01(id) {
      return this.restangular.one("getAttachmentTab01/" + id);
    }

    public submitAttachmentTab02() {
      return this.restangular.all("submitAttachmentTab02");
    }

    public getAttachmentTab02(id) {
      return this.restangular.one("getAttachmentTab02/" + id);
    }

    public submitAttachmentTab03() {
      return this.restangular.all("submitAttachmentTab03");
    }

    public getAttachmentTab03(id) {
      return this.restangular.one("getAttachmentTab03/" + id);
    }




    
  printMyObjectiveReport() {
    return this.restangular.all('printMyObjectiveReport');
  }

  printMyObjectiveReportNew() {
    return this.restangular.all('printMyObjectiveReportNew');
  }


  printMyAssesPaperReport() {
    return this.restangular.all('printMyAssesPaperReport');
  }

  public getMyObjectiveGapAnalysis(id) {
    return this.restangular.one("getMyObjectiveGapAnalysis/" + id);
  }



  public referBackRejectObjective() {
    return this.restangular.all("referBackRejectObjective");
  }




  generateObjectiveCertificate() {
    return this.restangular.one('generateObjectiveCertificate');
  }




  public addApprovalLevels() {
    return this.restangular.one("addApprovalLevels");
  }

  public editApprovalSettings() {
    return this.restangular.all("editApprovalSettings");
  }



  public addTemplateHeaders() {
    return this.restangular.one("addTemplateHeaders");
  }

  public editTempReference() {
    return this.restangular.all("editTempReference");
  }

  public deleteTempReference(id) {
    return this.restangular.one("deleteTempReference/" + id);
  }





  public getTemplateHeaders(id) {
    return this.restangular.one("getTemplateHeaders/" + id);
  }

  public getApprovalLevels(id) {
    return this.restangular.one("getApprovalLevels/" + id);
  }


  public managerOnlyReferBackRemove() {
    return this.restangular.all("managerOnlyReferBackRemove");
  }



  public getApproveRoleMasters(id) {
    return this.restangular.one("getApproveRoleMasters/" + id);
  }


  public getNavigationUserGroups(id) {
    return this.restangular.one("getNavigationUserGroups/" + id);
  }


  public addRoleRecord() {
    return this.restangular.one("addRoleRecord");
  }

  public deleteRoleMaster(id) {
    return this.restangular.one("deleteRoleMaster/" + id);
  }


  public addRoleEmployees() {
    return this.restangular.all("addRoleEmployees");
  }


  public getApproveRoleEmployees(id) {
    return this.restangular.one("getApproveRoleEmployees/" + id);
  }

  public deleteRoleEmployee(id) {
    return this.restangular.one("deleteRoleEmployee/" + id);
  }


  
  public updateRoleMaster() {
    return this.restangular.all("updateRoleMaster");
  }

  public updateRoleEmployees() {
    return this.restangular.all("updateRoleEmployees");
  }

  public getRowToDetailTemplate(id) {
    return this.restangular.one("getRowToDetailTemplate/" + id);
  }

  public deleteDetailedTemplateRow() {
    return this.restangular.one("deleteDetailedTemplateRow");
  }

  public confirmDetailCreateTemplate() {
    return this.restangular.one("confirmDetailCreateTemplate");
  }

  public deleteDetailsAssignedEmps(id) {
    return this.restangular.one("deleteDetailsAssignedEmps/" + id);
  }


}



// WEBPACK FOOTER //
// /app/src/app/services/objectives.service.ts